import React from "react";
import { Alert, CircularProgress, Typography } from "@mui/material";
import { UploadJob } from "../hooks/useVideoUpload";

interface UploadProgressDisplayProps {
  uploadJobs: UploadJob[];
}

export const UploadProgressDisplay: React.FC<UploadProgressDisplayProps> = ({
  uploadJobs,
}) => {
  if (uploadJobs.length === 0) return null;

  return (
    <>
      {uploadJobs.map((job, index) => {
        const message = `Uploading ${job.file.name}, please don't navigate away or refresh the
    page. ${job.progress}% uploaded...`;

        return (
          <Alert
            key={job.evidenceID}
            severity="info"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              position: "fixed",
              bottom: `${index * 80 + 10}px`,
              left: "35px",
              zIndex: 9999,
              maxWidth: "600px",
            }}
            icon={
              <CircularProgress
                variant="determinate"
                value={job.progress}
                color="primary"
              />
            }
          >
            <Typography variant="body2" mb="5px">
              {message}
            </Typography>
          </Alert>
        );
      })}
    </>
  );
};
